import { render, staticRenderFns } from "./fish_species.vue?vue&type=template&id=0540dd7a&scoped=true"
import script from "./fish_species.vue?vue&type=script&lang=js"
export * from "./fish_species.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0540dd7a",
  null
  
)

export default component.exports